import ModernPortfolio from './ModernPortfolio';

function App() {
  return <ModernPortfolio />;
}

export default App;
